/*
 *
 * Dataset constants
 *
 */
import { COL_AMOUNT, ROW_AMOUNT } from '@appspotr/app';
export var MAX_HEIGHT = 400;
export var MAX_WIDTH = 80;
/** this is the amount of times wider a component should be initially in landscape mode */
export var LANDSCAPE_RATIO = Math.floor((ROW_AMOUNT / 2 / COL_AMOUNT) * 100) / 100;
export var UPDATE_GROUPED_SELECTED_COMPONENTS = 'app/ViewBuilder/UPDATE_GROUPED_SELECTED_COMPONENTS';
export var UPDATE_GROUP_SELECTION = 'app/ViewBuilder/UPDATE_GROUP_SELECTION';
export var DROP_COMPONENT = 'app/ViewBuilder/DROP_COMPONENT';
export var LOAD_LAYOUT_REQUEST = 'app/ViewBuilder/LOAD_LAYOUT_REQUEST';
export var LOAD_LAYOUT_SUCCESS = 'app/ViewBuilder/LOAD_LAYOUT_SUCCESS';
export var LOAD_LAYOUT_FAILURE = 'app/ViewBuilder/LOAD_LAYOUT_FAILURE';
export var LOAD_STYLE_REQUEST = 'app/StylesPage/LOAD_STYLE_REQUEST';
export var LOAD_STYLE_SUCCESS = 'app/StylesPage/LOAD_STYLE_SUCCESS';
export var LOAD_STYLE_FAILURE = 'app/StylesPage/LOAD_STYLE_FAILURE';
export var SAVE_LAYOUT_REQUEST = 'app/ViewBuilder/SAVE_LAYOUT_REQUEST';
export var SAVE_LAYOUT_SUCCESS = 'app/ViewBuilder/SAVE_LAYOUT_SUCCESS';
export var SAVE_LAYOUT_FAILURE = 'app/ViewBuilder/SAVE_LAYOUT_FAILURE';
export var SELECT_GRID_COMPONENT = 'app/ViewBuilder/SELECT_GRID_COMPONENT';
export var REMOVE_GRID_COMPONENT = 'app/ViewBuilder/REMOVE_GRID_COMPONENT';
export var CHANGE_BG_COLOR = 'app/ViewBuilder/CHANGE_BG_COLOR';
export var CHANGE_BG_IMAGE = 'app/ViewBuilder/CHANGE_BG_IMAGE';
export var TOGGLE_PORTRAIT = 'app/ViewBuilder/TOGGLE_PORTRAIT';
export var CHANGE_DEVICE_SCALE = 'app/ViewBuilder/CHANGE_DEVICE_SCALE';
export var SET_NAME = 'app/ViewBuilder/SET_NAME';
export var OVERRIDE_STYLE = 'app/ViewBuilder/OVERRIDE_STYLE';
export var ASSIGN_OUTPUT = 'app/ViewBuilder/ASSIGN_OUTPUT';
export var ASSIGN_STATE = 'app/ViewBuilder/ASSIGN_STATE';
export var ON_LAYOUT_CHANGE = 'app/ViewBuilder/ON_LAYOUT_CHANGE';
export var CHANGE_PADDING = 'app/ViewBuilder/CHANGE_PADDING';
export var CHANGE_COMPONENT_VALUE = 'app/ViewBuilder/CHANGE_COMPONENT_VALUE';
export var CHANGE_COMPONENT_MIN_MAX_VALUE = 'app/ViewBuilder/CHANGE_COMPONENT_MIN_MAX_VALUE';
export var CHANGE_COLOR = 'app/ViewBuilder/CHANGE_COLOR';
export var LOCK_COMPONENT = 'app/ViewBuilder/LOCK_COMPONENT';
export var ADD_IO = 'app/ViewBuilder/ADD_IO';
export var OPEN_MODAL = 'app/ViewBuilder/OPEN_MODAL';
export var CHANGE_CUSTOM_STYLES = 'app/ViewBuilder/CHANGE_CUSTOM_STYLES';
export var EDIT_IO = 'app/ViewBuilder/EDIT_IO';
export var REMOVE_IO = 'app/ViewBuilder/REMOVE_IO';
export var LOAD_FILES_REQUEST = 'app/ViewBuilder/LOAD_FILES_REQUEST';
export var LOAD_FILES_SUCCESS = 'app/ViewBuilder/LOAD_FILES_SUCCESS';
export var LOAD_FILES_FAILURE = 'app/ViewBuilder/LOAD_FILES_FAILURE';
export var GET_DATASET_REQUEST = 'app/ViewBuilder/GET_DATASET_REQUEST';
export var GET_DATASET_SUCCESS = 'app/ViewBuilder/GET_DATASET_SUCCESS';
export var GET_DATASET_FAILURE = 'app/ViewBuilder/GET_DATASET_FAILURE';
export var GET_DATASET_FIELDS_REQUEST = 'app/ViewBuilder/GET_DATASET_FIELDS_REQUEST';
export var GET_DATASET_FIELDS_SUCCESS = 'app/ViewBuilder/GET_DATASET_FIELDS_SUCCESS';
export var GET_DATASET_FIELDS_FAILURE = 'app/ViewBuilder/GET_DATASET_FIELDS_FAILURE';
export var RESET_BG_COLOR = 'app/ViewBuilder/RESET_BG_COLOR';
export var RESET_BG_IMAGE = 'app/ViewBuilder/RESET_BG_IMAGE';
export var OPEN_COMPONENT_LIST = 'app/ViewBuilder/SHOW_COMPONENT_LIST';
export var CLOSE_COMPONENT_LIST = 'app/ViewBuilder/CLOSE_COMPONENT_LIST';
export var GET_DATASETS_REQUEST = 'app/ViewBuilder/GET_DATASETS_REQUEST';
export var GET_DATASETS_SUCCESS = 'app/ViewBuilder/GET_DATASETS_SUCCESS';
export var GET_DATASETS_FAILURE = 'app/ViewBuilder/GET_DATASETS_FAILURE';
export var GET_VIEWS_REQUEST = 'app/ViewBuilder/GET_VIEWS_REQUEST';
export var GET_VIEWS_SUCCESS = 'app/ViewBuilder/GET_VIEWS_SUCCESS';
export var GET_VIEWS_FAILURE = 'app/ViewBuilder/GET_VIEWS_FAILURE';
export var CHANGE_VIEW_PADDING = 'app/ViewBuilder/CHANGE_VIEW_PADDING';
export var TOGGLE_COMPONENT_EXCLUSIVE = 'app/ViewBuilder/TOGGLE_COMPONENT_EXCLUSIVE';
export var SET_DATASET_SEPARATOR = 'app/ViewBuilder/SET_DATASET_SEPARATOR';
export var SET_STICKY_HEADER = 'app/ViewBuilder/SET_STICKY_HEADER';
export var CHANGE_DATASET_SEPARATOR_COLOR = 'app/ViewBuilder/CHANGE_DATASET_SEPARATOR_COLOR';
export var SET_SLIDER_STYLE = 'app/ViewBuilder/SET_SLIDER_STYLE';
export var RESET_SLIDER_STYLE = 'app/ViewBuilder/RESET_RESET_SLIDER_STYLE';
export var CHANGE_DATASET_SLIDER_TEXT_COLOR = 'app/ViewBuilder/CHANGE_DATASET_SLIDER_TEXT_COLOR';
export var CHANGE_DATASET_SLIDER_TEXT_SIZE = 'app/ViewBuilder/CHANGE_DATASET_SLIDER_TEXT_SIZE';
export var CHANGE_DATASET_SLIDER_TEXT_WEIGHT = 'app/ViewBuilder/CHANGE_DATASET_SLIDER_TEXT_WEIGHT';
export var CHANGE_DATASET_SLIDER_FONT_FAMILY = 'app/ViewBuilder/CHANGE_DATASET_SLIDER_FONT_FAMILY';
export var CHANGE_DATASET_SLIDER_BACKGROUND_COLOR = 'app/ViewBuilder/CHANGE_DATASET_SLIDER_BACKGROUND_COLOR';
export var CHANGE_DATASET_SEPARATOR_HEIGHT = 'app/ViewBuilder/CHANGE_DATASET_SEPARATOR_HEIGHT';
export var TOGGLE_LIST_ITEM_BORDER = 'app/ViewBuilder/TOGGLE_LIST_ITEM_BORDER';
export var SET_LIST_ITEM_BORDER_PROPERTY = 'app/ViewBuilder/SET_LIST_ITEM_BORDER_PROPERTY';
export var RESET_DATASET_SEPARATOR = 'app/ViewBuilder/RESET_DATASET_SEPARATOR';
export var ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER = 'app/ViewBuilder/ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER';
export var CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS = 'app/ViewBuilder/CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS';
export var RESET_DATASET_LIST_GROUPING_HEADER_FIELDS = 'app/ViewBuilder/RESET_DATASET_LIST_GROUPING_HEADER_FIELDS';
export var SET_FULLSCREEN = 'app/ViewBuilder/SET_FULLSCREEN';
export var SET_FLOW = 'app/ViewBuilder/SET_FLOW';
export var TOGGLE_ORIENTATION = 'app/ViewBuilder/TOGGLE_ORIENTATION';
export var TOGGLE_FONT_SCALLING = 'app/ViewBuilder/TOGGLE_FONT_SCALLING';
export var RESET_LAYOUT = 'app/ViewBuilder/RESET_LAYOUT';
export var CHANGE_COMPONENT_DIMENSIONS = 'app/ViewBuilder/CHANGE_COMPONENT_DIMENSIONS';
export var GET_DATASET_ROWS_REQUEST = 'src/ViewBuilder/GET_DATASET_ROWS_REQUEST';
export var GET_DATASET_ROWS_SUCCESS = 'src/ViewBuilder/GET_DATASET_ROWS_SUCCESS';
export var GET_DATASET_ROWS_FAILURE = 'src/ViewBuilder/GET_DATASET_ROWS_FAILURE';
export var SAVE_DATASET_NON_LIST_LAYOUT_REQUEST = 'src/ViewBuilder/SAVE_DATASET_NON_LIST_LAYOUT_REQUEST';
export var SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS = 'src/ViewBuilder/SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS';
export var SAVE_DATASET_NON_LIST_LAYOUT_FAILURE = 'src/ViewBuilder/SAVE_DATASET_NON_LIST_LAYOUT_FAILURE';
export var SAVE_LIST_VIEW_LAYOUT_REQUEST = 'src/ViewBuilder/SAVE_LIST_VIEW_LAYOUT_REQUEST';
export var SAVE_LIST_VIEW_LAYOUT_SUCCESS = 'src/ViewBuilder/SAVE_LIST_VIEW_LAYOUT_SUCCESS';
export var SAVE_LIST_VIEW_LAYOUT_FAILURE = 'src/ViewBuilder/SAVE_LIST_VIEW_LAYOUT_FAILURE';
// multi state component constants
export var UPDATE_SELECTED_TAB = 'src/ViewBuilder/ComponentProperties/UPDATE_SELECTED_TAB';
export var ADD_COMPONENT_STATE_SELECTED_COMPONENT = 'src/ViewBuilder/ComponentProperties/ADD_COMPONENT_STATE_SELECTED_COMPONENT';
export var UPDATE_LOGIC_SELECETD_COMPONENT_STATE = 'src/ViewBuilder/ComponentProperties/UPDATE_LOGIC_SELECETD_COMPONENT_STATE';
export var DELETE_COMPONENT_STATE = 'src/ViewBuilder/ComponentProperties/DELETE_COMPONENT_STATE';
export var UPDATE_COMPONENT_STATE_NAME = 'src/ViewBuilder/ComponentProperties/UPDATE_COMPONENT_STATE_NAME';
export var COPY_COMPONENT_STATE = 'src/ViewBuilder/ComponentProperties/COPY_COMPONENT_STATE';
export var GET_DATASET_RULES_REQUEST = 'app/ViewBuilder/GET_DATASET_RULES_REQUEST';
export var GET_DATASET_RULES_SUCCESS = 'app/ViewBuilder/GET_DATASET_RULES_SUCCESS';
export var GET_DATASET_RULES_FAILURE = 'app/ViewBuilder/GET_DATASET_RULES_FAILURE';
export var LOAD_STORAGE_REQUEST = 'app/ViewBuilder/LOAD_STORAGE_REQUEST';
export var LOAD_STORAGE_SUCCESS = 'app/ViewBuilder/LOAD_STORAGE_SUCCESS';
export var LOAD_STORAGE_FAILURE = 'app/ViewBuilder/LOAD_STORAGE_FAILURE';
export var SET_VIEW_DELETE_MODAL_STATE = 'app/ViewBuilder/SET_VIEW_DELETE_MODAL_STATE';
export var SET_VIEW_DUPLICATE_MODAL_STATE = 'app/ViewBuilder/SET_VIEW_DUPLICATE_MODAL_STATE';
